import { render, staticRenderFns } from "./QuotationMenu.vue?vue&type=template&id=4e6d11bd&scoped=true&"
import script from "./QuotationMenu.vue?vue&type=script&lang=js&"
export * from "./QuotationMenu.vue?vue&type=script&lang=js&"
import style0 from "./QuotationMenu.vue?vue&type=style&index=0&id=4e6d11bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6d11bd",
  null
  
)

component.options.__file = "QuotationMenu.vue"
export default component.exports